import { useState } from 'react';
import NotificationMapper from '../mappers/NotificationMapper';
import { useIsOpenedStore } from '../NotificationCenterStore';
import GET_CURRENT_USER_NOTIFICATIONS from '../queries/getCurrentUserNotificationQuery';
import { useBackgroundQuery } from '@apollo-internal/hooks/useBackgroundQuery';
import { useShallow } from 'zustand/shallow';

const PAGE_SIZE = 20;

export const useNotificationPagination = (notifications, addNotification, clear) => {
  const isOpen = useIsOpenedStore(useShallow(state => state.isOpened));

  const [continuationToken, setContinuationToken] = useState(null);
  const [nextContinuationToken, setNextContinuationToken] = useState(null);
  const [showUnreadOnly, toggleShowUnreadOnly] = useState(true);

  const { loading } = useBackgroundQuery(GET_CURRENT_USER_NOTIFICATIONS, {
    skip: !isOpen,
    fetchPolicy: 'cache-and-network',
    variables: {
      continuationToken,
      limit: PAGE_SIZE,
      includeRead: !showUnreadOnly
    },
    onCompleted: data => {
      data.currentUserNotifications.Notifications.map(NotificationMapper.mapNotification).forEach(
        addNotification
      );

      setNextContinuationToken(data.currentUserNotifications.ContinuationToken);
    }
  });

  const filteredNotifications = showUnreadOnly ? notifications.filter(x => !x.read) : notifications;

  const fetchMoreData = () => {
    setContinuationToken(nextContinuationToken);
  };

  const toggleShowUnread = () => {
    toggleShowUnreadOnly(prev => !prev);
    clear();
    setContinuationToken(null);
  };

  return {
    showUnreadOnly,
    toggleShowUnread,
    loading,
    filteredNotifications,
    fetchMoreData,
    hasMore: nextContinuationToken !== null
  };
};
